const SAP_items = [
    {
      "id": "1.0",
      "name": "Strategy & Roadmap, Proof of Concepts, and Execution"
    },
    {
      "id": "2.0",
      "name": "Boardroom Solutions for Executives"
    },
    {
      "id": "3.0",
      "name": "Integration with On-Premise Transactional & BI Systems – SAP & Non-SAP"
    },
    {
      "id": "4.0",
      "name": "Consumption of Data from SAP BW, ECC, SAP HANA & SAP BOBJ (UNX)"
    },
    {
      "id": "5.0",
      "name": "Connectivity to Cloud Platforms such as Salesforce & SuccessFactors"
    },
    {
      "id": "6.0",
      "name": "Self-Service Analytics Using SAP Analytics Cloud"
    },
    {
      "id": "7.0",
      "name": "Enhanced Planning & Predictive Capabilities"
    }
  ]
export default SAP_items;